import React, { useState } from 'react';
import { FilterInputContainer } from '../../Commons/Facelift/Filters/styles';
import { TSelectOptionProps } from '@gerdau/hefesto/Select/Select.types';
import { Select } from '@gerdau/hefesto/Select';

interface IStatesSelectProps {
  title: string;
  states: TSelectOptionProps[];
  selectedStates: string[];
  onChangeState(states: string[]): void;
  disabled: boolean;
  loading: boolean;
  placeholder?: string;
}

const StatesSelect: React.FC<IStatesSelectProps> = ({
  title,
  states,
  selectedStates,
  onChangeState,
  disabled,
  loading,
  children,
  placeholder
}) => {
  const [isSelectedAll, setIsSelectedAll] = useState<boolean>(false);
  const statesValues = states.map((state) => state.value);

  return (
    <FilterInputContainer>
      {loading && <>{children}</>}
      {!loading && (
        <Select
          {...(placeholder && { placeholder })}
          label={title}
          name={'dropdownState'}
          value={isSelectedAll ? [...selectedStates, 'all'] : selectedStates}
          options={
            states.length > 1
              ? [{ label: 'Selecionar todos', value: 'all' }, ...states]
              : states
          }
          disabled={disabled}
          isMultipleSelect={true}
          onSelect={(value: string | string[]) => {
            const onlySelectedStates = (value as string[]).filter(
              (selectedState) => selectedState !== 'all'
            );
            const isAllSelectedStates =
              onlySelectedStates.length === states.length;

            // Entra se todas as opções estiver marcada, e em seguida desmarca a opção de selecionar todos
            if (
              !(value as string[]).includes('all') &&
              isAllSelectedStates &&
              isSelectedAll
            ) {
              setIsSelectedAll(false);
              return onChangeState([]);
            }

            // Entra caso identifique que todas as opções disponiveis foi selecionada e marca a opção selecionar todos
            if (isAllSelectedStates) {
              setIsSelectedAll(true);
              return onChangeState([...statesValues]);
            }

            // Entra caso a opção selecionar todos foi marcada

            if ((value as string[]).includes('all') && !isSelectedAll) {
              setIsSelectedAll(true);
              return onChangeState([...statesValues]);
            }

            // Selecionou uma opção diferente de selecionar todos e não foram todos selecionados
            setIsSelectedAll(false);
            return onChangeState(onlySelectedStates);
          }}
        ></Select>
      )}
    </FilterInputContainer>
  );
};

export default StatesSelect;
